import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ErrorResponse } from '@aibees/shared/definition';
import { UseMutationResult } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ENRICHMENT_STATE } from '../../types';
import { SaveRecordRequest } from '../types';

export function usePersonalityAnalysisStatus(
  saveApi?: UseMutationResult<void, ErrorResponse, SaveRecordRequest, any>,
  people?: PeopleTableInfo
) {
  const { isItemProcessing } = useActionButtonContext();

  return useMemo(() => {
    const state = people?.revelation?.analysis?.state;
    const failed = state === ENRICHMENT_STATE.FAILED;
    const disabled = !people;
    let text = 'Unlock';
    if (failed) text = 'Retry Analysis';
    return { failed, disabled, text };
  }, [people, saveApi?.isLoading, saveApi?.status, isItemProcessing]);
}
